const {
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CONTINUE_OPERATION,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CONTINUE_OPERATION_VALIDATE,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CHANGE_ACCEPT_EVALUATION,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_OPERATE_OMITTING_TEST,
    BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_NOT_CONVENIENT_ACCEPT
} = require('constants/actionTypes.js');

const validate = () => ({
    type: BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CONTINUE_OPERATION_VALIDATE,
    payload: {}
});

const continueOperation = () => (dispatch, getState) => {
    dispatch(validate());

    const immBrokerConvenienceMiFIDTest = getState().brokerConvenienceMiFIDTest;

    if (!immBrokerConvenienceMiFIDTest.get('isEvaluationAcceptedInvalid')) {
        dispatch({
            type: BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CONTINUE_OPERATION,
            payload: {}
        });
    }
};

const changeAcceptEvaluation = (value) => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_CHANGE_ACCEPT_EVALUATION,
        payload: {
            isEvaluationAccepted: value
        }
    });
};

const operateOmittingTest = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_OPERATE_OMITTING_TEST,
        payload: {}
    });
};

const notConvenientAccept = () => (dispatch) => {
    dispatch({
        type: BROKER_CONVENIENCE_MIFID_TEST_STEP_SUCCESS_NOT_CONVENIENT_ACCEPT,
        payload: {}
    });
};

module.exports = {
    continueOperation,
    changeAcceptEvaluation,
    operateOmittingTest,
    notConvenientAccept
};
